import { PaginatedRequestParams } from "api";
import { Dayjs } from "dayjs";

export enum UpLoadingFilterFormField {
  MaterialName = 'MaterialName',
  DriverName = 'DriverName',
  VehicleNumber = "VehicleNumber",
  Date = 'date',
  Status = 'Status',
}

export type UpLoadingFilterFormValues = {
  [UpLoadingFilterFormField.MaterialName]: string | undefined;
  [UpLoadingFilterFormField.DriverName]: string | undefined;
  [UpLoadingFilterFormField.VehicleNumber]: string | undefined;
  [UpLoadingFilterFormField.Date]: [Dayjs | undefined, Dayjs | undefined] | null;
  [UpLoadingFilterFormField.Status]: string | undefined;
};

export type UpLoadingFilterFormValuesPaginated = UpLoadingFilterFormValues &
  PaginatedRequestParams;